/** Fluent elevation ramp (shadow2 → shadow64): a tight ambient shadow plus a soft key shadow. */
const boxShadows = {
  xs: "0 0 2px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.28)",
  sm: "0 0 2px rgba(0, 0, 0, 0.24), 0 2px 4px rgba(0, 0, 0, 0.28)",
  md: "0 0 2px rgba(0, 0, 0, 0.24), 0 4px 8px rgba(0, 0, 0, 0.28)",
  lg: "0 0 2px rgba(0, 0, 0, 0.24), 0 8px 16px rgba(0, 0, 0, 0.28)",
  xl: "0 0 8px rgba(0, 0, 0, 0.24), 0 14px 28px rgba(0, 0, 0, 0.28)",
  "2xl": "0 0 8px rgba(0, 0, 0, 0.24), 0 32px 64px rgba(0, 0, 0, 0.28)",
  xxl: "0 0 8px rgba(0, 0, 0, 0.24), 0 32px 64px rgba(0, 0, 0, 0.28)",
  inner: "inset 0 1px 2px 0 rgb(0 0 0 / 0.06)",
  none: "0 0 #0000",
  xxs: "0 0 2px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.28)",
  regular: "0 0 2px rgba(0, 0, 0, 0.24), 0 4px 8px rgba(0, 0, 0, 0.28)",
  navbarBoxShadow: "0 0 2px rgba(0, 0, 0, 0.24), 0 2px 4px rgba(0, 0, 0, 0.28)",
  sliderBoxShadow: {
    thumb: "0 0 2px rgba(0, 0, 0, 0.24), 0 1px 2px rgba(0, 0, 0, 0.28)",
  },
  tabsBoxShadow: {
    indicator: "none",
  },
  inset: "inset 0 1px 2px 0 rgb(0 0 0 / 0.06)",
  colored: {
    primary: "0 4px 16px 0px rgba(71, 158, 245, 0.28)",
    secondary: "0 4px 16px 0px rgba(138, 138, 138, 0.28)",
    info: "0 4px 16px 0px rgba(56, 189, 248, 0.28)",
    success: "0 4px 16px 0px rgba(52, 211, 153, 0.28)",
    warning: "0 4px 16px 0px rgba(251, 191, 36, 0.28)",
    error: "0 4px 16px 0px rgba(248, 113, 113, 0.28)",
    light: "0 4px 16px 0px rgba(138, 138, 138, 0.28)",
    dark: "0 4px 16px 0px rgba(0, 0, 0, 0.28)",
  },
};

export default boxShadows;
